import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  message?: string;
  icon?: React.ReactNode;
  inCard?: boolean;
  className?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export default function EmptyState({
  message = 'Нема податоци.',
  icon,
  inCard = false,
  className = '',
  action,
}: EmptyStateProps) {
  const inner = (
    <div className={`text-center py-8 text-muted-foreground ${className}`}>
      {icon && <div className="flex justify-center mb-3">{icon}</div>}
      <p>{message}</p>
      {action && (
        <Button className="mt-4" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );

  if (inCard) {
    return (
      <Card>
        <CardContent className="p-6">{inner}</CardContent>
      </Card>
    );
  }

  return inner;
}
